import { css } from "@emotion/css";

export const styles = css`
  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    background: white;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    padding: 8px;
  }
`;
